const TRANSLATION = {
  common: {
    loading: 'Yükleniyor',
  },
  i18n: {
    English: 'İngilizce',
    Spanish: 'İspanyolca',
    Russian: 'Rusça',
    'Portuguese (Brazil)': 'Portekizce (Brezilya)',
    Indonesian: 'Endonezyaca',
    Czech: 'Çekçe',
    German: 'Almanca',
    French: 'Fransızca',
    Italian: 'İtalyanca',
    Dutch: 'Hollandaca',
    Polish: 'Lehçe',
    Vietnamese: 'Vietnamca',
    Turkish: 'Türkçe',
    Ukrainian: 'Ukraynaca',
    Chinese: 'Basitleştirilmiş Çince',
    'Traditional Chinese': 'Geleneksel Çince',
    Japanese: 'Japonca',
    Korean: 'Korece',
    Arabic: 'Arapça',
    Persian: 'Farsça',
    Thai: 'Tayca',
    Hindi: 'Hintçe',
    Malay: 'Malayca',
    province: {
      Hebei: 'Hebei Eyaleti',
      Shanxi: 'Shanxi Eyaleti',
      Liaoning: 'Liaoning Eyaleti',
      Jilin: 'Jilin Eyaleti',
      Heilongjiang: 'Heilongjiang Eyaleti',
      Jiangsu: 'Jiangsu Eyaleti',
      Zhejiang: 'Zhejiang Eyaleti',
      Anhui: 'Anhui Eyaleti',
      Fujian: 'Fujian Eyaleti',
      Jiangxi: 'Jiangxi Eyaleti',
      Shandong: 'Shandong Eyaleti',
      Henan: 'Henan Eyaleti',
      Hubei: 'Hubei Eyaleti',
      Hunan: 'Hunan Eyaleti',
      Guangdong: 'Guangdong Eyaleti',
      Hainan: 'Hainan Eyaleti',
      Sichuan: 'Sichuan Eyaleti',
      Guizhou: 'Guizhou Eyaleti',
      Yunan: 'Yunnan Eyaleti',
      Shaanxi: 'Shaanxi Eyaleti',
      Gansu: 'Gansu Eyaleti',
      Qinghai: 'Qinghai Eyaleti',
      Taiwan: 'Taiwan Eyaleti',
      Guangxi: 'Guangxi Zhuang Özerk Bölgesi',
      Neimenggu: 'İç Moğolistan Özerk Bölgesi',
      Tibet: 'Tibet Özerk Bölgesi',
      Ningxia: 'Ningxia Hui Özerk Bölgesi',
      Xinjiang: 'Sincan Uygur Özerk Bölgesi',
      HongKong: 'Hong Kong Özel İdare Bölgesi',
      Macau: 'Makao Özel İdare Bölgesi',
      Beijing: 'Pekin Belediyesi',
      Tianjin: 'Tianjin Belediyesi',
      Shanghai: 'Şanghay Belediyesi',
      Chongqing: 'Chongqing Belediyesi',
    },
  },
  pageHeader: {
    product: 'Ürün',
    tvcTest: 'TVC Deneyim Testi',
    tvcEval: 'TVC Yaratıcılık Değerlendirmesi',
    contactUs: 'Bize Ulaşın',
    Pricing: 'Fiyatlandırma',
    Dashboard: 'Hemen Başlayın',
    signIn: 'Giriş Yap',
    signUp: 'Kayıt Ol',
    resourceCenter: 'Blog',
    all: 'Tümü',
    news: 'Haberler',
    insight: 'İçgörü',
    case: 'Örnek',
  },
  productSwitch: {
    common: {
      comingSoon: 'Yakında',
    },
    modal: {
      heroTitle: 'Lütfen çalıştırmak istediğiniz testi seçin',
      heroSubtitle:
        'AdEff, ihtiyaç duyduğunuzda size çok boyutlu yaratıcı içgörüler sunmaya her zaman hazırdır.',
      remainingTimes: 'Kalan kullanım: {{count}}',
      supportedAssets: 'Desteklenen içerikler',
      coreMetrics: 'Temel metrikler',
      cognitiveNeuroscienceIndicators: 'Bilişsel-nöral göstergeler',
      consumerAttitudeIndicators: 'Tüketici tutum göstergeleri',
      outputResult: 'Çıktı sonucu',
      dataReport: 'Veri raporu',
      analysisReport: 'Analiz raporu',
      accessBackend: 'Hemen Başlayın',
      tabs: {
        tvc: 'Yatay Yaratıcı Testi',
        portrait: 'Dikey Yaratıcı Testi',
      },
      cards: {
        tvcQuick: {
          title: 'Yatay-Hızlı test',
          descriptionHighlight:
            'Veriye dayalı kararları desteklemek için kreatifleri hızla değerlendirin',
        },
        tvcBase: {
          title: 'Yatay-Kreatif Tanı',
          descriptionHighlight:
            'Yaratıcı detayları, uygulanabilir düzenleme önerileriyle inceltin',
          value1: '10–60 sn TVC/OTV kreatifler',
          value2: 'Bilişsel-nöral göstergeler',
        },
        tvcSurvey: {
          title: 'Yatay-InsightPro',
          descriptionHighlight:
            'Stratejik optimizasyon rehberliğiyle çok boyutlu kreatif analiz',
          value1: '10–60 sn TVC/OTV kreatifler',
          value2: 'Bilişsel-nöral göstergeler',
        },
        portraitQuick: {
          title: 'Dikey-Hızlı test',
          descriptionHighlight:
            'Veriye dayalı kararları desteklemek için kreatifleri hızla değerlendirin',
        },
        portraitBase: {
          title: 'Dikey-Kreatif Tanı',
          descriptionHighlight:
            'Yaratıcı detayları, uygulanabilir düzenleme önerileriyle inceltin',
          value1: '5–90 sn dikey kreatifler',
          value2: 'Bilişsel-nöral göstergeler',
        },
        portraitSurvey: {
          title: 'Dikey-InsightPro',
          descriptionHighlight:
            'Stratejik optimizasyon rehberliğiyle çok boyutlu kreatif analiz',
          value1: '5–90 sn dikey kreatifler',
          value2: 'Bilişsel-nöral göstergeler',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Yatay Kreatif Testi',
          assetText: '10-60 sn TVC/OTV kreatifleri için',
        },
        portrait: {
          bannerTitle: 'Dikey Kreatif Testi',
          assetText: '5-90 sn dikey kreatifler için',
        },
      },
      items: {
        tvcQuick: {
          description: 'Kreatifleri hızlıca karşılaştırın ve karar verin',
        },
        tvcBase: {
          title: 'Kreatif Tanı',
          description: 'Saniye saniye optimizasyonla kreatifleri rafine edin',
        },
        tvcSurvey: {
          title: 'Derin İçgörü',
          description: 'Kapsamlı analizle sorunları net biçimde belirleyin',
        },
        portraitBase: {
          title: 'Kreatif Tanı',
          description: 'Saniye saniye optimizasyonla kreatifleri rafine edin',
        },
        portraitQuick: {
          description: 'Kreatifleri hızlıca karşılaştırın ve karar verin',
        },
        portraitSurvey: {
          title: 'Derin İçgörü',
          description: 'Kapsamlı analizle sorunları net biçimde belirleyin',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Çerezleri Kullanıyoruz',
    desc: 'Web sitemizin düzgün çalışmasını sağlamak için gerekli çerezleri kullanıyoruz. Onayınızla, kullanıcı deneyiminizi geliştirmek için analiz çerezleri de kullanıyoruz. Gizlilik politikamızda çerez politikamızı inceleyin.',
    btn1: 'Hepsini Reddet',
    btn2: 'Hepsini Kabul Et',
    cookiePolicy: 'Çerez Politikası',
  },
  landing: {
    banner: {
      text1: 'AI Destekli',
      text2: 'Reklam',
      text3: 'Test',
      text4: 'Yaratıcı Test ve Optimizasyon Platformu',
      feature1: 'İçerik Çözümleme',
      feature2: 'Geri Bildirim Tahmini',
      feature3: 'Veri Entegrasyonu',
      feature4: 'Sonuç Çıkarımı',
      btn1: 'Demo Al',
      btn2: 'Proje Oluştur',
    },
    info: {
      title:
        'Hiper Grafik Çok Modlu Büyük Dil Modeli (HMLLM)* ile hızlı bir şekilde yaratıcı etkilerin tahminini yaparak reklam yatırım getirisini artırın',
      subTitle:
        '*Bu model, geniş bir sinir pazarlama testi ve çoklu ajan yapılandırmasına dayanmaktadır',
      detail1: 'Hızlı Reklam Testi',
      detail1Desc:
        'AdEff, hedef kitle dikkat eğrisi, duygusal dalgalanma ve yaratıcı içerik etkileşimi hakkında 15 dakika içinde bilgi alabilir ve ayrıntılı değerlendirme raporu ve optimizasyon rehberi sunar.',
      detail2: 'En İyi Yaratıcıları Hızla Seçin',
      detail2Desc:
        'AdEff, birden fazla yaratıcıyı aynı anda ölçmeyi destekler ve markaların hızlı kararlar almasına yardımcı olur. Ayrıntılı karşılaştırma analizi sunar.',
      detail3: 'Tek Tıkla Kurgulama, Çeşitli Etkili Versiyonlar Üretin',
      detail3Desc:
        'AdEff, tek tıkla kurgulama ile hızlı bir şekilde çeşitli etkili versiyonlar üretebilir, farklı iletişim senaryolarına uygundur.',
    },
    advantages: {
      title: 'AdEff Avantajları',
      item1Title: 'Hızlı Yanıt',
      item1Desc: 'En hızlı <tmp>15 dakika</tmp> içinde rapor alabilirsiniz.',
      item2Title: 'Eşsiz AI Modeli',
      item2Desc: 'Kitle geri bildirimine dayanan <tmp>AI modeli</tmp>.',
      item3Title: 'Görselleştirilmiş Grafikler',
      item3Desc:
        '<tmp>Görselleştirilmiş grafikler</tmp> + AI akıllı yorumlama, test raporu tek tıkla oluşturulur',
      item4Title: 'Büyük Veri Aralığı',
      item4Desc: '<tmp>50,000+</tmp> yaratıcı veritabanı',
      item5Title: 'Uzman Takımı',
      item5Desc: '<tmp>Uzman takımı</tmp> destek ve rehberlik sağlar',
    },
    service: {
      title: 'AdEff Hizmet Yöntemleri',
      desc: 'İhtiyacınız olan hizmet yöntemini seçin',
      topTitle: 'Çevrimiçi Kendinize Hizmet',
      topRow1: 'Kendi projenizi oluşturun ve testi tamamlayın',
      topRow2: 'Görselleştirilmiş grafikler + AI yorumlama raporu',
      topRow3: 'Objektif sinir bilimsel gösterge analizi (göz hareketi + beyin dalgası)',
      topRow4: 'Eşsiz AI modeli testi',
      bottomTitle: 'Uzman Takım Hizmeti',
      bottomRow1: 'Uzman projesi tamamlayın',
      bottomRow2:
        'Objektif sinir bilimsel gösterge analizi (göz hareketi + beyin dalgası), isteğe bağlı olarak öznel göstergeler eklenebilir',
      bottomRow3: 'Görselleştirilmiş grafikler + uzman yorumlama raporu',
      bottomRow4: 'Eşsiz AI modeli testi, isteğe bağlı olarak gerçek insan örneği testi',
    },
    footer: {
      title:
        'AdEff, Hiper Grafik Çok Modlu Büyük Dil Modeli (HMLLM) üzerine inşa edilmiştir ve karmaşık ilişkileri hızlı bir şekilde test etmek için görsel unsurlar EEG sinyalleri ve göz hareketi verileri arasında kurar',
      email: 'E-posta',
      belongDesc: '<tmp>Mininglamp Technology</tmp> ürünü',
    },
    startBtn: 'Hemen Başlayın',
  },
  contact: { title: 'Bize Ulaşın', copy: 'Kopyala', message: { success: 'Başarıyla kopyalandı' } },
  pricing: {
    title: 'Yapay Zeka Destekli Yaratıcı Test ve Optimizasyon Uzmanı',
    starter: {
      title: 'Başlangıç',
      desc_1: 'Tek kullanımlık testler için uygun, satın aldıktan sonra hemen kullanıma hazır',
      desc_2: 'Küçük ölçekli testler için uygun, satın aldıktan sonra hemen kullanıma hazır',
      timesDesc: '<strong>{{count}}</strong> kez her türlü reklam testi için',
      timesDesc1: '<strong>{{count}}</strong> kez her türlü reklam testi için',
      discount: '%50 indirim',
      originPrice: 'Fiyat',
      desc2: 'Kitle geri bildirimine dayalı hiper grafik çok modlu büyük dil modeli',
      desc3: 'Hızlı yanıt, en hızlı 15 dakika içinde rapor oluşturma',
      desc4: 'Zengin görselleştirilmiş grafikler',
      desc5: 'Profesyonel AI akıllı yorumlama',
      desc6: 'Küresel veritabanı ve kıyaslama',
      cardDesc1: 'Sınırlı süreli indirim, sadece {{pricePerTest}}',
      cardDesc2: 'Test kotası asla sona ermez',
    },
    premium: {
      time: 'kez',
    },
    unlimited: {
      title: 'Sınırsız',
      cardDesc1: '{{pricePerTest}} fiyatından başlayan',
      cardDesc2: 'Kota bir yıl boyunca geçerlidir',
      cardDesc3: 'Özelleştirilmiş özel benchmark',
      planDesc500: 'Yıl boyunca 500 testten yararlanın',
      planDesc1000: 'Yıl boyunca 1.000 testten yararlanın',
    },
    benefits: {
      title: 'Neden AdEff’i seçmelisiniz?',
      subtitle: 'AdEff ile aşağıdaki avantajlardan yararlanabilirsiniz:',
      expertSupport: 'Uzman ekip desteği ve yönlendirmesi',
      moreNeedsTitle: 'Başka satın alma ihtiyaçlarınız mı var?',
      customPlanPrefix: 'Esnek ve özelleştirilmiş planları destekliyoruz — bize şu adresten ulaşın:',
      customPlanSuffix: 'size özel çözümünüz için',
    },
    subscribeBtn: 'Hemen Abone Ol',
    contactUs: 'Bize Ulaşın',
  },
  login: {
    loginText: 'Giriş Yap',
    signUpText: '<tmp>Kayıt Ol</tmp> Ücretsiz',
    text1: 'Takıma başarıyla katıldınız',
    text1Desc:
      'AdEff, HMLLM üzerine inşa edilmiştir ve karmaşık ilişkileri hızlı bir şekilde test etmek için görsel unsurlar EEG sinyalleri ve göz hareketi verileri arasında kurar',
    text2: 'Kullanıcı şirkete katıldı',
    text3: 'Takım daveti süresi dolmuş',
    text4: 'Takım davet bağlantısı artık geçerli değil.',
    optionText1: 'Zaten bir hesabınız var mı?',
    optionText2: 'Hesabınız yok mu?',
    alertText1: 'Kayıt olarak, kabul ediyorum',
    alertText2: 'Kabul ediyorum',
    termsOfService: 'Hizmet Şartları',
    privacy: 'Gizlilik Politikası',
    privacyTips: 'Kayıt olmadan önce lütfen onay kutusunu işaretleyin.',
    and: 've',
    or: 'veya',
    next: 'Sonraki',
    googleLogin: 'Google ile Giriş Yap',
    googleSignUp: 'Google ile Kayıt Ol',
    loginWithEmail: 'E-posta ile Giriş Yap',
    signUpWithEmail: 'E-posta ile Kayıt Ol',
    password: 'Şifre',
    emailAddress: 'E-posta Adresi',
    enterEmail: 'E-posta adresinizi girin',
    enterPassword: 'Şifrenizi girin',
    confirmPassword: 'Şifreyi Onayla',
    forgotPassword: 'Şifrenizi mi unuttunuz?',
    inconsistentPassword: 'Şifreler uyuşmuyor',
    verificationCode: 'Doğrulama Kodu',
    emptyVerificationCode: 'Doğrulama kodu boş olamaz',
    enterVerificationCode: 'Doğrulama kodunu girin',
    sendedVerificationCode: 'Doğrulama kodu e-posta adresinize gönderildi',
    emailOrPasswordNotCorrect: 'E-posta veya şifre yanlış.',
    message: {
      text1: 'Geçersiz giriş',
      text2: 'E-posta zaten kayıtlı',
      text3: 'Doğrulama kodu hatalı!',
      text4: 'Bu hesap kuruluşa bağlı değil, lütfen yeniden bağlayın!',
      text5: 'Lütfen geçerli bir e-posta formatı girin',
      text6: 'Şifrenin minimum uzunluğu 12 karakter olmalıdır',
      text7: 'Şifre büyük harf, küçük harf ve rakam içermelidir',
      requestLimit: 'İstek limiti aşıldı, lütfen daha sonra tekrar deneyin',
    },
  },
  resetPwdPage: {
    submit: 'Gönder',
    emailNotFound: 'E-posta adresinizi kontrol edin',
    emailHasSent: 'E-posta {{email}} adresine gönderildi',
    checkYourInbox: 'Gmail klasörünüzü kontrol edin',
    resetYourPassword: 'Şifrenizi sıfırlayın',
    resetLinkHasSent:
      'Bir e-posta, şifrenizi sıfırlamak için bir bağlantı gönderildi. Lütfen e-posta adresinize kontrol edin',
    enterYourEmailAddress: 'E-posta adresinizi girin ve şifrenizi sıfırlayın',
    didNotGetEmail: 'E-posta almadın mı?',
    tryAgain: 'Tekrar deneyin',
    goBackToSign: 'Giriş Yap',
    email: 'E-posta',
    enterYourEmail: 'E-posta adresinizi girin',
    resetPassword: 'Şifrenizi Sıfırla',
    resetPwdSuccess: 'Şifre başarıyla sıfırlandı',
    message: {
      resetLinkCodeError: 'Bağlantı kodu geçersiz',
      requestLimit: 'İstek limiti aşıldı, lütfen daha sonra tekrar deneyin',
    },
  },
  memberRequestPage: {
    title: 'Üye Talebini Doğrula',
    subTitle: 'Talep eden: ',
    deny: 'Reddet',
    approve: 'Onayla',
    teamFull: 'Takım dolu',
    yourTeamIsFull:
      'Takımınız dolu. Daha fazla üye almak için bizimle iletişime geçebilirsiniz veya diğer üyeleri kaldırabilirsiniz.',
    manageMembers: 'AdEff içindeki üyeleri yönet',
    requestApproved: 'Talep onaylandı',
    approvedDesc:
      '<tmp>{{name}}</tmp>’in takımınıza katılmasına onay verdiniz, otomatik olarak bildirim e-postası gönderildi.',
    requestDeclined: 'Talep reddedildi',
    declinedDesc:
      '<tmp>{{name}}</tmp>’in takımınıza katılmasına onay vermediniz, otomatik olarak bildirim e-postası gönderildi.',
  },
  infoBindPage: {
    title: 'AI Destekli Reklam Testi',
    desc: 'Hiper Grafik Çok Modlu Büyük Dil Modeli (HMLLM)* ile hızlı bir şekilde yaratıcı etkilerin tahminini yaparak reklam yatırım getirisini artırın',
    joinAdEff: 'AdEff’e katılın ve yeni bir yolculuğa başlayın',
    advantages: {
      title1: 'Daha Güçlü',
      desc1: 'Büyük veri tabanına dayanan eşsiz AI modeli',
      title2: 'Daha Ekonomik',
      desc2: 'Geleneksel yöntemlerin sadece %10 fiyatı',
      title3: 'Daha Hızlı',
      desc3: 'En hızlı 15 dakikada rapor alabilirsiniz',
      title4: 'Daha Profesyonel',
      desc4: '24/7 hizmet desteği ve uzman ekip hizmeti',
    },
    username: 'Kullanıcı Adı',
    company: 'Şirket',
    placeOfResidence: 'Ülke/Bölge',
    invitationCode: 'Referans Kodu',
    createAccountForFree: 'Ücretsiz Hesap Oluştur',
    refreshStatus: 'Durumu Yenile',
    reapply: 'Yeniden Başvur',
    bySigningUp: 'Kayıt olarak kabul ediyorum',
    termsOfService: 'Hizmet Şartları',
    and: 've',
    privacyPolicy: 'Gizlilik Politikası',
    message: {
      success: 'Hesap oluşturma talebi gönderildi, lütfen bekleyin!',
      success2: 'Hesap başarıyla oluşturuldu',
      error: 'Hesap oluşturma başarısız, lütfen daha sonra tekrar deneyin.',
      accountCreatedDirectly: 'Hesabınız doğrudan oluşturuldu!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'Talep onaylandı, sayfa otomatik olarak yönlendirilecektir.',
      theRequestHasBeenSendAndPleaseBePatient: 'Talep gönderildi, lütfen bekleyin!',
      wrongRouting: 'Yönlendirme hatası, sayfa otomatik olarak yönlendirilecektir.',
      yourRequestHasBeenDeclined:
        'Talebiniz reddedildi. Takıma yeniden katılmak için yeniden başvurabilir veya davet kodu olmadan yeni bir hesap oluşturabilirsiniz.',
      waitingForAdministratorReview: 'Yönetici incelemesini bekliyor',
      thisFieldIsRequired: 'Bu alan gereklidir',
      pleaseEnterTheResidence: 'Lütfen ülkeyi girin',
      invitationCodeDoesNotExist: 'Geçersiz referans kodu',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Eğer bunu bir acente referansı aracılığıyla kullanıyorsanız, lütfen referans kodunu girin',
      pleaseEnterTheUsername: 'Lütfen kullanıcı adını girin',
      pleaseEnterTheCompanyName: 'Lütfen şirket adını girin',
      needRegisterAgain: 'İşlem hatası, lütfen tekrar kayıt olun',
      alreadyBind: 'Şirket zaten bağlandı, lütfen tekrar bağlanmayın',
    },
  },
  knowledgeFormPage: {
    name: 'Adınız',
    email: 'E-posta Adresiniz',
    companyName: 'Şirket Adı',
    department: 'Departman',
    role: 'Pozisyon',
    country: 'Ülke',
    province: 'Şehir/Bölge',
    pleaseEnter: 'Lütfen girin',
    pleaseSelect: 'Lütfen seçin',
    pleaseEnterTheName: 'Lütfen adınızı girin',
    pleaseEnterTheEmail: 'Lütfen e-posta adresinizi girin',
    pleaseEnterValidEmail: 'Lütfen geçerli bir e-posta girin',
    pleaseEnterTheCompanyName: 'Lütfen şirket adını girin',
    pleaseSelectTheDepartment: 'Lütfen departmanınızı seçin',
    pleaseSelectTheRole: 'Lütfen pozisyonunuzu seçin',
    pleaseSelectTheCountry: 'Lütfen ülkenizi seçin',
    pleaseSelectTheProvince: 'Lütfen şehir/bölge seçin',
    textIsRequired: 'Bu alan gereklidir',
    submit: 'Gönder',
    download: 'İndir',
    submitSuccess: 'Gönderildi',
    downloadSuccess: 'İndirildi',
    title1: 'Kaynaklara ulaşmak için lütfen bilgilerinizi doldurun',
    title2: 'İndirmek istediğiniz kaynakları seçin',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Raporu İndir',
      downloadBtnText: 'PDF İndir',
      content: 'İçerik',
      theEnd: 'Son',
      thankYouForWatching: 'İzleme için teşekkürler.',
      pdfProcessing: 'PDF işleniyor...',
      pdfProcessingDesc: 'PDF sayfası: {{count}}，{{seconds}} saniye beklemenizi rica ediyoruz',
      pdfProcessingDesc2: 'Şu anki dil sürümü çevirilmedi, PDF oluşturulamaz',
    },
    ppt: {
      downloadBtnText: 'PPT İndir',
      pptProcessingDesc: 'PPT dosyası oluşturuluyor, lütfen bekleyin',
      pptProcessingDesc2: 'Mevcut dil sürümü çevrilmedi, PPT oluşturulamıyor',
      pptProcessingDesc3: 'PPT dosyası indiriliyor, lütfen bekleyin...',
      translateCompleted: 'PPT çevirisi tamamlandı',
      exportSuccess: 'PPT dosyası başarıyla dışa aktarıldı',
      exportFailed: 'PPT dosyası dışa aktarılamadı',
    },
    layout: {
      projectMenuText: 'Reklam Test Projeleri',
      accountManagementText: 'Hesap Yönetimi',
      myAccountText: 'Hesabım',
      subscriptionText: 'Abonelik',
      logout: 'Çıkış Yap',
      dataDetails: 'Veri Ayrıntıları',
      dataAnalysis: 'Veri Analizi',
      dataOverview: 'Veri Genel Bakışı',
      dataComparison: 'Veri Karşılaştırması',
    },
    systemMessage: {
      title: 'Sistem Mesajı',
      task: 'Görev',
      system: 'Sistem',
      noRelevantContent: 'İlgili içerik bulunamadı',
      noMore: 'Daha fazla mesaj yok',
    },
    projectPage: {
      createProject: 'Proje Oluştur',
      searchPlaceholder: 'Proje/Reklam/Marka adını girerek ara',
      sortLabel: 'Reklam Efekt İndeksi Sıralama',
      sortPlaceholder: 'Sıralama yöntemini seçin',
      sortOption1: 'Efekt indeksine göre artan',
      sortOption2: 'Efekt indeksine göre azalan',
      filterSort: 'Filtrele ve sırala',
      filterBenchmarkTitle: 'Benchmark filtrele',
      sortTitle: 'Sırala',
      tabAllCreative: 'Tüm kreatifler ({{count}})',
      tabGeneralCreative: 'Normal kreatifler ({{count}})',
      tabSplashCreative: 'Splash kreatifler ({{count}})',
      generalCreativeLabel: 'Normal kreatif',
      splashCreativeLabel: 'Splash kreatif',
      normTypePlaceholder: 'Lütfen norm tipini seçin',
      totalDesc: 'Reklam Projeleri (Toplam {{total}})',
      noRelevantContent: 'İlgili içerik bulunamadı',
      loadMore: 'Daha fazla yükle',
      projectCard: { delete: 'Sil', reanalyze: 'Yeniden Analiz Et', download: 'İndir' },
      delete: 'Sil',
      cancel: 'İptal',
      message: {
        deleteTitle: 'Silme Hatırlatması',
        delete:
          'Bu projeyi sildiğinizde, tüm ilişkili veriler erişilemez hale gelecektir. Devam etmek istediğinizden emin misiniz?',
        delete1:
          'Bu proje bir test projesi ve silme işlemi, test projesi için bir kerelik fırsatınızı geri alacaktır.',
        delete2:
          'Bu proje henüz analize başlamadı. Silme işleminden sonra test kredileriniz iade edilecektir',
        deleteSuccess: 'Silme işlemi başarılı!',
        analysisCountNotEnough: 'Analiz sayısı yeterli değil, lütfen yüklemek için yükleme yapın.',
        analysisFailed: 'Analiz başarısız, lütfen daha sonra tekrar deneyin.',
        waitingQuestion:
          'Aynı anda en fazla 3 proje analiz edilebilir. Bu proje bekleme kuyruğuna alındı ve yakında otomatik olarak analiz başlayacak.',
        landscapeQuickCompleted: 'Yatay hızlı test projeniz tamamlandı.',
        portraitQuickCompleted: 'Dikey hızlı test projeniz tamamlandı.',
        landscapeSurveyCompleted: 'Yatay derin içgörü projeniz tamamlandı.',
        portraitSurveyCompleted: 'Dikey derin içgörü projeniz tamamlandı.',
      },
    },
    projectCreatePage: {
      createProject: 'Proje Oluştur',
      basicInformation: 'Temel Bilgiler',
      projectType: 'Proje Türü',
      projectName: 'Proje Adı',
      categoryType: 'Sektör',
      brandName: 'Marka Adı',
      advertisingInformation: 'Reklam Bilgisi',
      adName: 'Reklam Adı',
      norm: 'Norm',
      targetMarketNorm: 'Hedef Pazar Normu',
      brandNorm: 'Marka Normu',
      taGender: 'Hedef Kitle Cinsiyeti',
      targetMarket: 'Hedef Pazar',
      taAge: 'Hedef Kitle Yaşı',
      next: 'Sonraki',
      previous: 'Önceki',
      confirmOrder: 'Siparişi Onayla',
      estTime: 'Tahmini Süre',
      minutes: 'Dakika',
      consumption: 'Bu siparişin tüketimi',
      testPoint: 'Test Sayısı',
      remaining: 'Kalan',
      times: 'kez',
      type: 'Tür',
      purchase: 'Satın Al',
      outputLanguage: 'Çıktı Dili',
      durationCategory: 'Kreatif Türü',
      durationCategoryDesc: 'Analiz metrikleri kreatif türüne göre değişir, lütfen içeriğinize en uygun seçeneği seçin.',
      durationCategoryOptions: {
        tenPlus: 'Genel Kreatif (10sn+)',
        fiveToTen: 'Açılış Kreatifi (5-10sn)',
      },
      adSelection: {
        adCreativeTest: 'Reklam Yaratıcı Testi',
        adCreativeTestDesc:
          'Tek bir reklam yaratıcı için kitle geri bildirimini test etme, analiz ve öneri sağlama',
        adCreativeSelection: 'Reklam Yaratıcı Seçimi',
        adCreativeSelectionDesc:
          'Birden fazla reklam yaratıcının geri bildirim etkisini karşılaştırma, kapsamlı karşılaştırma ile seçim yapma',
        adCreativeEditing: 'Reklam Yaratıcı Düzenleme',
        adCreativeEditingDesc:
          'AI akıllı olarak reklam yaratıcılarının özünü seçer, otomatik olarak reklam yaratıcıları oluşturur',
        launchingSoon: 'Yakında Yayında',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Gıda ve İçecek Sektörü',
        packagedFood: 'Paketli Gıda',
        confectionery: 'Şekerleme',
        frozenMeals: 'Donatılmış Yemekler',
        fastFood: 'Hızlı Yemek',
        beverage: 'İçecek',
        alcohol: 'Alkol',
        dairy: 'Süt',
        grainAndSeasoning: 'Un/Baharat',
        beverageMixes: 'İçecek Karışımları',
        freshProduce: 'Taze Ürünler',
        otherFoodAndBeverage: 'Diğer Gıda ve İçecek',
        /**----------------------- */
        consumerElectronicsCategory: 'Tüketici Elektronik Ürünleri',
        mobilePhone: 'Akıllı Telefon',
        computer: 'Bilgisayar',
        smartDevice: 'Akıllı Cihaz',
        phoneAccessories: 'Telefon Aksesuarları',
        computerAccessories: 'Bilgisayar Aksesuarları',
        software: 'Yazılım',
        camera: 'Kamera',
        officeSupplies: 'Ofis Malzemeleri',
        otherConsumerElectronics: 'Diğer Elektronik Ürünler',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Eczacılık ve Sağlık Sektörü',
        otcMedicine: 'Otc İlaç',
        prescriptionDrugs: 'Reçete İlaç',
        healthSupplements: 'Sağlık Destek Ürünleri',
        pharmaceuticalCompanies: 'Eczacılık Şirketleri',
        medicalDevices: 'Tıbbi Aletler',
        medicalServices: 'Tıbbi Hizmetler',
        pharmacy: 'Eczane',
        otherPharmaceuticalsAndHealthCare: 'Diğer Eczacılık ve Sağlık',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Güzellik ve Kişisel Bakım Sektörü',
        hairCare: 'Saç Bakımı',
        womenSkincare: 'Kadın cilt bakımı',
        homeCleaning: 'Ev Temizliği',
        bodyCare: 'Beden Bakımı',
        feminineCare: 'Kadın Sağlık Bakımı',
        oralCare: 'Ağız Bakımı',
        menSkincare: 'Erkek Sağlık Bakımı',
        makeup: 'Kozmetik',
        fragrances: 'Parfüm',
        beautyServices: 'Güzellik Hizmetleri',
        otherBeautyAndPersonalCare: 'Diğer Güzellik ve Kişisel Bakım',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Bebek ve Çocuk Ürünleri',
        babyFood: 'Bebek Yemekleri',
        babyCareEssentials: 'Bebek Bakım Ürünleri',
        babyToys: 'Bebek Oyuncakları',
        otherMaternalAndInfantProducts: 'Diğer Bebek ve Çocuk Ürünleri',
        /**----------------------- */
        networkAndCommunicationCategory: 'Ağ ve İletişim Sektörü',
        mobileCarriers: 'Hesap Sağlayıcıları',
        internetProviders: 'İnternet Sağlayıcıları',
        telecomEquipment: 'Telekom Aksesuarları',
        otherNetworkAndCommunication: 'Diğer Ağ ve İletişim',
        /**----------------------- */
        travelAndAccommodationCategory: 'Seyahat ve Konaklama Sektörü',
        localTourism: 'Yerel Turizm',
        bookingPlatform: 'Rezervasyon Platformu',
        hotels: 'Otel',
        airlines: 'Uçak',
        airport: 'Havaalanı',
        otherTravelAndAccommodation: 'Diğer Seyahat ve Konaklama',
        /**----------------------- */
        vehiclesCategory: 'Araçlar Sektörü',
        motorVehicleProductsAndServices: 'Motorlu Araç Ürünleri ve Hizmetleri',
        carBrands: 'Araç Markaları',
        dealerships: 'Satıcılar',
        carFinance: 'Araç Finansmanı',
        evCar: 'Elektrikli Araçlar',
        motorcycle: 'Motorsiklet',
        onlineUsedCarMarketplace: 'Kullanılmış Araç Satış Platformu',
        carRentalPlatform: 'Araç Kiralama Platformu',
        travelNavigation: 'Seyahat Navigasyonu',
        bicycle: 'Bisiklet',
        otherVehicles: 'Diğer Araçlar',
        /**----------------------- */
        householdAppliancesCategory: 'Ev Aletleri Sektörü',
        majorAppliances: 'Büyük Ev Aletleri',
        healthAndPersonalCareAppliances: 'Sağlık ve Kişisel Bakım Aletleri',
        majorKitchenAndBathAppliances: 'Büyük Mutfak ve Banyo Aletleri',
        smallKitchenAppliances: 'Küçük Mutfak ve Banyo Aletleri',
        environmentalAppliances: 'Çevresel Aletler',
        cleaningAppliances: 'Temizlik Aletleri',
        otherHouseholdAppliances: 'Diğer Ev Aletleri',
        /**----------------------- */
        retailAndServiceCategory: 'Perakende ve Hizmet Sektörü',
        onlineRetailEcommerce: 'Online Perakende/E-Ticaret',
        departmentStores: 'Departman Mağazaları',
        lifeServices: 'Yaşam Hizmetleri',
        retailServicesAndDelivery: 'Perakende Hizmetleri/Teslimat',
        supermarkets: 'Süpermarket',
        otherRetailAndService: 'Diğer Perakende ve Hizmet',
        /**----------------------- */
        apparelCategory: 'Giyim ve Aksesuarlar Sektörü',
        footwear: 'Ayakkabı',
        clothing: 'Giyecek',
        watchesWatchRetail: 'Saat/Saat Mağazası',
        jewelry: 'Seyahat',
        bags: 'Çanta',
        eyewearOpticalStores: 'Gözlük/Gözlük Mağazası',
        otherClothingAndAccessories: 'Diğer Giyim ve Aksesuarlar',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Ev İyileştirme ve Mobilya Sektörü',
        homeFurnishing: 'Mobilya',
        homeImprovement: 'Ev İyileştirme',
        otherHomeImprovementAndFurnishings: 'Diğer Ev İyileştirme ve Mobilya',
        /**----------------------- */
        financialAndInsuranceCategory: 'Finans ve Sigorta Sektörü',
        bank: 'Banka',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Yatırım ve Finans Hizmetleri',
        insurance: 'Sigorta',
        otherFinancialAndInsurance: 'Diğer Finans ve Sigorta',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Eğlence ve Hobi Sektörü',
        socialApp: 'Sosyal Uygulama',
        toysAndDolls: 'Oyuncak ve Bebek',
        concerts: 'Konser',
        events: 'Etkinlik',
        movies: 'Film',
        themeParks: 'Temal Park',
        gambling: 'Bahis',
        onlineGaming: 'Online Oyun',
        tvChannels: 'TV Kanalları',
        otherEntertainmentAndLeisure: 'Diğer Eğlence ve Hobi',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Endüstri ve Tarım Sektörü',
        industrialSupplies: 'Endüstriyel Malzemeler',
        agriculturalSupplies: 'Tarımsal Malzemeler',
        otherIndustrialAndAgricultural: 'Diğer Endüstri ve Tarım',
        /**----------------------- */
        petLifeCategory: 'Evcil Hayvan Ürünleri',
        petFood: 'Evcil Hayvan Yemekleri',
        petSupplies: 'Evcil Hayvan Aksesuarları',
        otherPetLife: 'Diğer Evcil Hayvan Ürünleri',
        /**----------------------- */
        educationAndLearningCategory: 'Eğitim ve Öğrenme Sektörü',
        onlineLearning: 'Online Eğitim',
        schools: 'Okul',
        skillCourses: 'Yetenek Kursları',
        tutoring: 'Öğretmen',
        universities: 'Üniversite',
        otherEducationAndLearning: 'Diğer Eğitim ve Öğrenme',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Topluluk ve Kamu Hizmetleri Sektörü',
        charityCampaigns: 'Kurban',
        ngoAds: 'NGO Reklamları',
        otherCommunityAndPublicService: 'Diğer Topluluk ve Kamu Hizmetleri',
        /**----------------------- */
        otherCategory: 'Diğer Sektörler',
        governmentAdvertising: 'Hükümet Reklamları',
        realEstateAdvertising: 'Emlak Reklamları',
        otherAdvertising: 'Diğer Reklamlar',
      },
      genderSelect: {
        male: 'Erkek',
        female: 'Kadın',
        all: 'Hepsi',
      },
      targetMarketSelect: {
        China: 'Çin',
        HongKongChina: 'Hong Kong, Çin',
        MacauChina: 'Makao, Çin',
        TaiwanChina: 'Tayvan, Çin',
        Japan: 'Japonya',
        Korea: 'Kore',
        Mongolia: 'Moğolistan',
        Singapore: 'Singapur',
        Thailand: 'Tayland',
        Vietnam: 'Vietnam',
        Malaysia: 'Malezya',
        Philippines: 'Filipinler',
        Indonesia: 'Endonezya',
        Cambodia: 'Kamboçya',
        Laos: 'Laos',
        India: 'Hindistan',
        SaudiArabia: 'Suudi Arabistan',
        Turkey: 'Türkiye',
        Israel: 'İsrail',
        UnitedArabEmirates: 'Birleşik Arap Emirlikleri',
        Qatar: 'Katar',
        Kuwait: 'Kuveyt',
        UnitedKingdom: 'Birleşik Krallık',
        France: 'Fransa',
        Germany: 'Almanya',
        Netherlands: 'Hollanda',
        Belgium: 'Belçika',
        Austria: 'Avusturya',
        Italy: 'İtalya',
        Spain: 'İspanya',
        Portugal: 'Portekiz',
        Greece: 'Yunanistan',
        Sweden: 'İsveç',
        Norway: 'Norveç',
        Finland: 'Finlandiya',
        Denmark: 'Danimarka',
        Estonia: 'Estonya',
        Latvia: 'Letonya',
        Russia: 'Rusya',
        Poland: 'Polonya',
        CzechRepublic: 'Çek Cumhuriyeti',
        Hungary: 'Macaristan',
        Romania: 'Romanya',
        Bulgaria: 'Bulgaristan',
        Slovakia: 'Slovakya',
        Slovenia: 'Slovenya',
        Ukraine: 'Ukrayna',
        UnitedStates: 'Amerika Birleşik Devletleri',
        Canada: 'Kanada',
        Mexico: 'Meksika',
        Brazil: 'Brezilya',
        LatinAmerica: 'Latin Amerika',
        Australia: 'Avustralya',
        NewZealand: 'Yeni Zelanda',
        Other: 'Diğer',
      },
      languageSelect: {
        english: 'İngilizce',
        chinese: 'Çince',
        japanese: 'Japonca',
        korean: 'Korece',
        french: 'Fransızca',
        traditionalChinese: 'Geleneksel Çince',
      },
      placeholder: {
        projectName: 'Lütfen proje adını girin',
        category: 'Lütfen kategori seçin',
        brandName: 'Lütfen marka adını girin',
        adName: 'Lütfen reklam adını girin',
        norm: 'Lütfen referans değeri seçin',
        taGender: 'Lütfen cinsiyeti seçin',
        targetMarket: 'Lütfen hedef pazarı seçin',
        taAge: 'Lütfen yaşı seçin',
        lowerLimit: 'Alt sınır',
        upperLimit: 'Üst sınır',
        outputLanguage: 'Lütfen çıktı dili seçin',
      },
      step: {
        step1: 'Proje Bilgileri Girişi',
        step2: 'Sipariş Bilgileri Onayı',
      },
      message: {
        success: 'Başarıyla oluşturuldu',
        videoDurationOver60s: 'Video süresi {{max}} saniyeden fazla',
        videoDurationLessThan10s: 'Video süresi {{min}} saniyeden az',
        videoDurationNeedOver10s: 'Video süresi 10 saniyeden uzun olmalıdır',
        videoDurationNeedWithin5To10s: 'Video süresi 5 saniye ile 10 saniye arasında olmalıdır',
        videoDurationNotMatchDurationCategory: 'Mevcut video süresi bu proje türünün gereksinimlerini karşılamıyor. Lütfen videoyu yeniden yükleyip tekrar deneyin.',
        videoUploadingCannotSwitchDurationCategory: 'Video yüklenirken kreatif türü değiştirilemez. Lütfen yükleme tamamlanana kadar bekleyin.',
        videoFormatOrDurationError: 'Video formatı veya süresi okunamadı. Lütfen video dosyasını kontrol edip tekrar deneyin.',
        videoSizeOver200M: "Video boyutu 256MB'dan fazla",
        videoLandscape: 'Video yatay olmalıdır',
        videoPortrait: 'Video dikey formatta olmalıdır',
        clickToUploadTestVideo: 'Test videosunu yüklemek için tıklayın',
        uploadFailed: 'Yükleme başarısız, lütfen tekrar yükleyin',
        uploadDesc1: 'Yatay ekran video dosyalarını destekler, formatlar MP4, MOV',
        uploadDescPortrait: 'MP4, MOV formatlarında dikey video dosyalarını destekler',
        uploadDesc2: 'Diğer formatlar, dosya boyutu sınırı 256MB ın üzerinde',
        formNotCompleted: 'Lütfen tüm bilgileri doldurun',
        uploadAdVideo: 'Lütfen reklam videosunu yükleyin',
        inputInvalid: 'Geçersiz giriş',
        insufficientTestPoints:
          'Yeterli test puanınız yok. Lütfen yeniden yükleyin ve tekrar deneyin.',
        reviewProjectInfo:
          'Lütfen proje bilgilerinizi dikkatlice kontrol edin. Sipariş onaylandıktan sonra değiştirilemez.',
        waitingDesc:
          'Aynı anda en fazla 3 proje analiz edilebilir. Bu proje bekleme kuyruğuna alındı ve yakında otomatik olarak analiz başlayacak.',
        ageRangeInvalid: 'Yaş aralığı yalnızca 20-55 desteklenir',
        normDesc:
          'Sektör veya tarihsel verilerin normu, reklam performansını yatay olarak karşılaştırmak için kullanılır.',
      },
    },
    projectDetailPage: {
      testResults: 'Test Sonuçları',
      share: 'Paylaş',
      shareFailed: 'Paylaşım başarısız',
      shareModal: {
        title: 'Paylaş',
        desc: 'Aşağıdaki metni kopyalayıp sosyal medyada paylaşın.',
        saveImage: 'Görseli Kaydet',
        copyText: 'Metni Kopyala',
        copySuccess: 'Kopyalandı',
        copyFailed: 'Kopyalama başarısız',
        textTemplate:
          "Vay canına! AI kreatifim AdEff'te benzer çalışmaların {{score}}% oranını geride bıraktı! Gerçek güç veride saklı! AdEff AI Creative Testing şimdi ücretsiz. Puanınızı {{hostname}} üzerinden kontrol edin. 5 ücretsiz test kazanın, harika değerlendirmeler almanızı dileriz!",
      },
      sharePoster: {
        createdByYou: 'Sizin oluşturduğunuz',
        scoreTemplate: 'AIGC yaratıcı çalışmalarının <score>{{score}}</score> seviyesini aştı',
        statsAt: 'İstatistik zamanı ',
        certification: 'Yaratıcılık Sertifikası',
        footerText: 'Daha fazla kaliteli eser üretmeniz için yaratıcılığınızın devamını dileriz!',
      },
      basicInformation: 'Temel Bilgiler',
      waiting: 'Beklemede',
      ongoing: 'Devam Ediyor',
      failed: 'Başarısız',
      tryAgain: 'Tekrar Dene',
      videoAnalysisFailed: 'Video analizi başarısız',
      message: { projectNotFound: 'Proje bulunamadı' },
      primaryAnalysis: 'Ana Performans',
      detailAnalysis: 'Anlık Analiz',
      heatmapAnalysis: 'Isı Haritası',
      analysisStepDesc: 'AI tüm analiz görevlerini tamamladı, ayrıntılı analiz aşağıdadır',
      analysisWaitingDesc:
        'Aynı anda en fazla 3 proje analiz edilebilir. Bu proje bekleme kuyruğuna alındı ve yakında otomatik olarak analiz başlayacak',
      aiTip: 'Rapor içeriği AI tarafından oluşturulmuştur ve sadece referans için sağlanmıştır',
      subAnalysisDescription: {
        adVideoScore: 'Reklam Etkisi İndeksi',
        adVideoScoreDesc:
          'Reklam etkisi indeksi, reklamın kısa ve uzun vadeli satış etkilerini tahmin etmek için kullanılan bir genel ölçüdür.',
        norm: 'Norm',
        normDesc:
          'Sektör veya tarihsel verilerin normu, reklam performansını yatay olarak karşılaştırmak için kullanılır.',
        attentionIndex: 'Dikkat İndeksi',
        attentionIndexDesc:
          'Hedef kitlenin görsel dikkatinin yoğunluğunu yansıtır, reklamın sahnesi ve unsurlarının izleyiciyi çekme yeteneğini gösterir.',
        emotionIndex: 'Duygu İndeksi',
        emotionIndexDesc:
          'Hedef kitlenin olumlu duygularının ne kadar tetiklendiğini yansıtır, reklamın anlık duygusal dalgalanmasını gösterir.',
        cognitionIndex: 'Kognitif İndeks',
        cognitionIndexDesc: 'Hedef kitlenin reklam içeriği üzerinde ne kadar düşündüğünü yansıtır.',
        theGolden3Seconds: 'Altın 3 Saniye',
        theGolden3SecondsDesc:
          'Reklamın ilk 3 saniyesi, reklamın başarısını belirleyen kritik bir andır.',
        informationTransmission: 'Bilgi Anı',
        informationTransmissionDesc:
          'Reklamın bilgi anının hedef kitle dikkatini yakalama yeteneğini ve ilgi uyandırma etkisini ölçer.',
        brandRelevance: 'Marka Anı',
        brandRelevanceDesc:
          'Marka anının hedef kitle dikkatini yakalama yeteneğini ve ilgi uyandırma etkisini ölçer.',
        interestStimulation: 'İlgi Anı',
        interestStimulationDesc:
          'Hedef kitlenin duygusal yankı ve aktif bilişini tetikleyen kritik içerik anıdır.',
        theEnding3Seconds: 'Son 3 Saniye',
        theEnding3SecondsDesc:
          'Zihin kuralları gereği, reklamın son 3 saniyesi izleyici dikkatini pekiştirmek ve bilgi iletimi güçlendirmek için kritik bir andır.',
      },
      infoDrawer: {
        basicInformation: 'Temel Bilgiler',
        advertisingInformation: 'Reklam Bilgisi',
        projectName: 'Proje Adı',
        brandName: 'Marka Adı',
        category: 'Sektör',
        norm: 'Hedef Pazar Normu',
        normLabel: 'Norm',
        brandNorm: 'Marka Normu',
        adName: 'Reklam Adı',
        taGender: 'Hedef Kitle Cinsiyeti',
        targetMarket: 'Hedef Pazar',
        taAge: 'Hedef Kitle Yaşı',
        ageRange: '{{start}} ile {{end}} yaş',
        modify: 'Düzenle',
        cancel: 'İptal',
        confirm: 'Onayla',
      },
      videoView: {
        eyeMovementRatio: 'Dikkat İndeksi',
        cognitiveEngagement: 'Kognitif İndeks',
        emotionRecognition: 'Duygu İndeksi',
        subjectiveResponseCurve: 'Öznel Tepki Eğrisi',
        realtimeData: 'Gerçek Zamanlı Veri',
        panoramicData: 'Panoramik Veri',
        indexAnalysis: 'İndeks Analizi',
        advantage: 'Avantaj',
        disadvantage: 'Dezavantaj',
        suggestions: 'Öneriler',
        adVideoScore: 'Reklam Etkisi İndeksi',
        norm: 'Norm',
        analysisStepTitle1: 'İçerik Çözümleme',
        analysisStepTitle2: 'Geri Bildirim Tahmini',
        analysisStepTitle3: 'Veri Entegrasyonu',
        analysisStepTitle4: 'Sonuç Çıkarımı',
        analysisStepDesc1:
          'Reklam içeriğinin çok modlu çözümlemesine başlar, görsel, ses, metin ve yapı çözümlemesi...',
        analysisStepDesc2:
          'Hedef kitlenin öznel tepkisini tahmin etmeye başlar, reklamın her saniyesine dayalı olarak, hedef kitlenin göz hareketi ve beyin dalgası verilerini tahmin eder...',
        analysisStepDesc3:
          'Reklamın nesnel içeriği ile hedef kitlenin öznel tepki verilerini birleştirmeye başlar...',
        analysisStepDesc4:
          'Çıkarım modeline dayalı olarak değerlendirme sonuçları ve eylem önerileri üretmeye başlar...',
        keyResult: 'Ana Sonuç',
        videoChart: {
          videoFailed: 'Video oynatma başarısız',
          videoFailedAction:
            'Lütfen güncelleyin ve tekrar deneyin. Sorun devam ederse, lütfen destek için bizimle iletişime geçin.',
        },
      },
      storyboardView: {
        summary: 'Özet',
        advantages: 'Avantajlar',
        disadvantages: 'Dezavantajlar',
        suggestions: 'Öneriler',
        keyResult: 'Ana Sonuç',
        norm: 'Norm',
        theGolden3Seconds: 'Altın 3 Saniye',
        informationTransmission: 'Bilgi Anı',
        brandRelevance: 'Marka Anı',
        interestStimulation: 'İlgi Anı',
        theEnding3Seconds: 'Son 3 Saniye',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'E-posta',
      username: 'Kullanıcı Adı',
      password: 'Şifre',
      setPasswordToEnableEmailLogin: 'E-posta ile giriş yapmak için şifre ayarlayın',
      uid: 'UID',
      contactAndReceiveNotifications: 'İletişim ve Bildirim Al',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Bu e-posta ile AdEff’in en son güncellemeleri hakkında e-postalar alın.',
      myWorkspace: 'Çalışma Alanım',
      newRequest: 'Yeni Talep',
      invitationCode: 'Referans Kodu',
      userName: 'Kullanıcı adı',
      invitationCodeDesc:
        'Her takımın, yeni kullanıcıların kayıt sırasında takıma katılma talep etmeleri için benzersiz bir davet kodu vardır',
      table: {
        userName: 'Kullanıcı Adı',
        email: 'E-posta',
        operation: 'İşlem',
        admin: 'Yönetici',
        remove: 'Kaldır',
        deny: 'Reddet',
        approve: 'Onayla',
      },
      message: {
        yourTeamIsFull:
          'Takımınız dolu. Daha fazla üye almak için bizimle iletişime geçebilirsiniz veya diğer üyeleri kaldırabilirsiniz.',
        invitationLinkSent: 'Davet bağlantısı bu e-posta adresine gönderildi!',
        removeReminder: 'Kaldırma Hatırlatması',
        remove: 'Kaldır',
        removeMember:
          'Üyeyi kaldırdığınızda, o üyenin oluşturduğu içerikler hala saklanacaktır. Üyeyi kaldırmak istediğinizden emin misiniz?',
        removeMemberSuccess: 'Üye başarıyla kaldırıldı!',
        ok: 'Tamam',
        contactUs: 'Bize Ulaşın',
        applicationProcessedSuccessfully: 'Başvuru başarıyla işlendi!',
        notificationSettingsTurnedOn: 'Bildirim ayarları açıldı',
        notificationSettingsTurnedOff: 'Bildirim ayarları kapatıldı',
        setPassword: 'Şifre Ayarla',
        passwordConfirm: 'Onayla',
        passwordCancel: 'İptal',
        oldPassword: 'Eski Şifre',
        newPassword: 'Yeni Şifre',
        pleaseEnterTheOldPassword: 'Lütfen eski şifreyi girin',
        pleaseEnterTheNewPassword: 'Lütfen yeni şifreyi girin',
        incorrectEntryOfOriginalPassword: 'Eski şifre hatalı girildi',
        passwordUpdatedSuccessfully: 'Şifre başarıyla güncellendi',
        changeUsername: 'Kullanıcı Adını Değiştir',
        confirm: 'Onayla',
        cancel: 'İptal',
        username: 'Kullanıcı Adı',
        pleaseEnterTheNewUsername: 'Lütfen yeni kullanıcı adını girin',
        userNameUpdatedSuccessfully: 'Kullanıcı adı başarıyla güncellendi',
        addMemberToWorkspace: 'Çalışma alanına yeni üye ekle',
        notAdminOperate: 'Yönetici değil, işlem yapamaz',
        emailAddress: 'E-posta Adresi',
        send: 'Gönder',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Bu adrese onay için bir davet e-postası göndereceğiz.',
        workspaceMemberShip: 'Çalışma Alanı Üyeliği',
        forMoreMembership: 'Daha Fazla Üyelik',
        reachedTheCeiling: 'Üye sayısı sınırına ulaşıldı.',
        incorrectMailboxFormat: 'E-posta formatı hatalı',
        member: 'Üye',
        changeCorpNameTitle: 'Şirket Adını Değiştir',
        changeCorpNameLabel: 'Şirket Adı',
        pleaseEnterTheCorpName: 'Lütfen şirket adını girin',
        changeCorpNameSuccess: 'Şirket adı başarıyla değiştirildi',
        changeCorpNameFailed: 'Şirket adı değiştirilemedi',
        noPermission: 'Şirket adını değiştirme yetkiniz yok',
      },
    },
    subscriptionPage: {
      currentPlan: 'Mevcut Plan',
      getInvoice: 'Faturayı Al',
      remainingTimes: 'Kalan Süre',
      purchaseMore: 'Daha Fazla Satın Al',
      contactUs: 'Bize Ulaşın',
      teamPlan: 'Uzman Takım Hizmeti',
      unlimited: 'Sınırsız',
      dueDate: 'Bitiş Tarihi',
      table: {
        usageRecords: 'Kullanım Kayıtları',
        date: 'Tarih',
        projectName: 'Proje Adı',
        projectType: 'Proje Türü',
        usageCount: 'kez',
        userName: 'Kullanıcı Adı',
        noRelevantContent: 'İlgili içerik bulunamadı',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Normal kreatif projesi',
      regularCreative: 'Normal kreatif',
      splashCreativeProject: 'Splash kreatif projesi',
      splashCreative: 'Splash kreatif',
      projects: 'Projeler',
      localNorm: 'Yerel benchmark',
      projectPassRate: 'Proje geçme oranı',
      passRate: 'Geçme oranı',
    },
    dataDetailPage: {
      baseData: 'Temel Veriler',
      totalProjects: 'Toplam Proje Sayısı',
      totalProjectsDesc:
        'Reklam etkinliği değerlendirmeye katılan tüm geçerli projelerin toplam sayısı.',
      // averageEffectivenessIndex: 'Ortalama Reklam Etkiliği İndeksi',
      // averageEffectivenessIndexDesc: 'Tüm geçerli projelerin ortalama reklam etkinliği indeksi.',
      localNormProjects: 'Yerel Norm Projeleri',
      brandNormProjects: 'Marka Norm Projeleri',
      normProject: 'Hedef Pazar Norm Projesi',
      brandNormProject: 'Marka Norm Projesi',
      localNorm: 'Yerel Norm',
      localNormDesc:
        'Bulunduğunuz ülkenin hedef pazar olduğu geçerli reklam projelerinin ortalama reklam etkinliği endeksi.',
      norm: 'Norm',
      brandNorm: 'Marka Normu',
      brandNormDesc:
        'Bulunduğunuz ülkenin hedef pazar olduğu geçerli reklam projelerinin ortalama reklam etkinliği endeksi.',
      localProjectPassRate: 'Yerel Proje Geçiş Oranı',
      projectPassRate: 'Proje Geçiş Oranı',
      brandProjectPassRate: 'Marka Proje Geçiş Oranı',
      projectPassRateDesc: 'Tüm geçerli projelerin ortalama reklam etkinliği indeksi.',
      advertisingEffectivenessIndexDistribution: 'Reklam Etkiliği İndeksi Dağılımı',
      advertisingEffectivenessIndexDistributionDesc: 'Reklam etkinliği indeksi dağılımı.',
      item: 'öğe',
    },
    dataComparisonPage: {
      createCompare: 'Yeni Karşılaştırma',
      createCompareDesc: 'Karşılaştırmak için en fazla 10 proje seçin.',
      startCompare: 'Karşılaştırmayı Başlat',
      compareReport: 'Karşılaştırma Raporları',
      searchPlaceholder: 'Karşılaştırma raporu adını ara',
      emptyText: 'Henüz karşılaştırma raporu yok. Önce karşılaştırılacak projeleri seçin.',
      searchEmptyText: 'Karşılaştırma raporu bulunamadı.',
      deleteTitle: 'Karşılaştırma Raporunu Sil',
      deleteConfirm: 'Bu karşılaştırma raporunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      projectCount: '{{count}} proje',
    },
    dataComparisonStartPage: {
      back: 'Geri',
      basicInfo: 'Temel Bilgiler',
      reportName: 'Rapor Adı:',
      reportNamePlaceholder: 'Karşılaştırma raporu adını girin',
      norm: 'Kıyas:',
      normPlaceholder: 'Kıyas seçin',
      normTip: 'Proje karşılaştırmasında kullanılacak kıyası seçin',
      selectProject: 'Projeleri Seç',
      searchPlaceholder: 'Proje/reklam/marka adına göre ara',
      selectedCountPrefix: ' Seçildi ',
      selectedCountSuffix: ' proje, en fazla {{max}} proje',
      startCompare: 'Karşılaştırmayı Başlat',
      save: 'Kaydet',
      cancel: 'İptal',
      maxSelectedWarning: 'En fazla 10 proje seçebilirsiniz',
      reportNameRequired: 'Karşılaştırma raporu adını girin',
      normRequired: 'Kıyas seçin',
      projectRequired: 'Projeleri seçin',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Karşılaştırma Raporu Adı',
      reportNotFound: 'Rapor bulunamadı',
      back: 'Geri',
      modify: 'Düzenle',
      deletedProjectTip: 'Aşağıdaki projeler: {{names}} silindi. Onaylandıktan sonra karşılaştırma raporu güncellenecek ve silinen projeler kaldırılacaktır.',
      confirmDeletedProjects: 'Onayla',
      metricScore: 'Gösterge Puanı',
      tabDimension: 'Beş Boyut',
      tabMoment: 'Kilit An',
      tabAttitude: 'Tüketici Tutumu',
      adeffScore: 'AdEff Skoru',
      brandName: 'Marka Adı',
      projectName: 'Proje Adı',
      industry: 'Sektör',
      targetMarket: 'Hedef Pazar',
      gender: 'TA Cinsiyeti',
      age: 'TA Yaşı',
      adProject: 'Reklam Projesi',
      normLabel: 'Kıyas',
      mixedCreativeBenchmarkTip: 'Genel kreatifler ve splash kreatifler aynı anda karşılaştırıldığında benchmark kullanılamaz.',
      emptyProject: 'Karşılaştırma verilerini görmek için projeleri seçin',
      viewProjectDetail: 'Proje Detaylarını Görüntüle',
      listSeparator: ', ',
      metricLabels: {
        attention: 'Dikkat Gücü',
        infectivity: 'Duygusal Güç',
        delivery: 'Mesaj Gücü',
        brand: 'Marka Gücü',
        persuasion: 'İkna Gücü',
        gazeRecognition: 'Bakış Tanıma',
        emotionRecognition: 'Duygu Tanıma',
        engagementRecognition: 'Etkileşim Tanıma',
        goldenSeconds: 'Altın 3 Saniye',
        brandMoment: 'Marka Anı',
        productMoment: 'İlgi Anı',
        messageMoment: 'Bilgi Anı',
        endingSeconds: 'Son 3 Saniye',
        likeability: 'Beğeni',
        newInformation: 'Yeni Bilgi',
        messageRelevance: 'Mesaj Alakası',
        comprehension: 'Anlama',
        credibility: 'Güvenilirlik',
        brandLinkage: 'Marka Bağlantısı',
        uniqueness: 'Benzersizlik',
        learnMoreIntent: 'Daha Fazla Öğrenme İsteği',
        purchaseIntent: 'Satın Alma Niyeti',
        recommendIntent: 'Paylaşılabilirlik',
        brandLikeabilityLift: 'Marka Beğeni Artışı',
        purchaseIntentionLift: 'Satın Alma Niyeti Artışı',
        attentionIndex: 'Dikkat İndeksi',
        emotionIndex: 'Duygu İndeksi',
        cognitionIndex: 'Kognitif İndeks',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'TVC yaratıcı değerlendirme projeniz tamamlandı.',
        title: {
          text1: 'Reklam Kreatif Testi',
          text2: 'Test Raporu',
        },
        flowAnalysis: {
          desc1: 'AdEff video reklamınızı ayrıştırıyor',
          desc2: 'Video ayrıştırma tamamlandı',
          desc3: 'Tüketici görsel dikkati analiz ediliyor',
          desc4: 'Tüketici profillerine göre görsel odak analiz ediliyor',
          desc5: 'Dikkat ısı haritası oluşturuluyor',
          desc6: 'Dinamik ısı haritası oluşturuldu',
          desc7: 'Bilişsel-nöral tepkiler ölçülüyor',
          desc8: 'Bakış, duygu ve etkileşim saniye saniye izleniyor',
          desc9: 'Nöral tepki eğrisi oluşturuluyor',
          desc10: 'Nöral tepki eğrisi oluşturuldu',
          desc11: 'Kilit anlardaki performans analiz ediliyor',
          desc12: 'Altın 3 saniye, mesaj anı, marka anı, ilgi zirvesi ve son 3 saniye boyunca bilişsel-nöral tepkiler ölçülüyor',
          desc13: 'Kilit an metrikleri sentezleniyor',
          desc14: 'Kilit an analizi tamamlandı',
          desc15: 'Tüketici tutumları analiz ediliyor',
          desc16: 'Marka, ürün ve içeriğe yönelik tutumlar analiz ediliyor',
          desc17: 'Tutum metrikleri sentezleniyor',
          desc18: 'Tutum metrikleri tamamlandı',
          desc19: 'Beş etki gücü skoru oluşturuluyor',
          desc20: 'Beş etki gücü skoru hazır',
          desc21: 'Analiz tamamlandı! Reklam performans raporunuz hazır',
          terminology: {
            thumbExpand: 'Küçük resimleri genişlet',
            thumbCollapse: 'Küçük resimleri daralt',
            gazeRecognition: 'Bakış Tanıma',
            gazeRecognitionDesc: 'Görsel dikkat yoğunluğunu ölçer ve reklam öğelerinin izleyici odağını ne kadar etkili yakaladığını gösterir.',
            emotionRecognition: 'Duygu Tanıma',
            emotionRecognitionDesc: 'Reklamın tetiklediği olumlu duyguları ve anlık duygusal tepkileri ölçer.',
            engagementRecognition: 'Etkileşim Tanıma',
            engagementRecognitionDesc: 'İçeriğe zihinsel yatırım düzeyini yansıtan dalma ve etkileşimi ölçer.',
            theGolden3Seconds: 'Altın 3 Saniye Performansı',
            theGolden3SecondsDesc: 'Reklam içeriğinin ilk 3 saniyedeki etkinliğini değerlendirir.',
            keyMessage: 'Kilit Mesaj Performansı',
            keyMessageDesc: 'Reklam bilgi anlarının dikkat yakalama ve ilgiyi artırma becerisini ölçer.',
            brand: 'Marka Performansı',
            brandDesc: 'Markaya özgü dikkat yakalama ve etkileşim etkinliğini değerlendirir.',
            interest: 'İlgi Zirvesi',
            interestDesc: 'Duygusal rezonans ve yüksek etkileşim tetikleyen içerik zirvelerini belirler.',
            ending3Seconds: 'Son 3 Saniye Performansı',
            ending3SecondsDesc: 'Reklam içeriğinin son 3 saniyedeki etkinliğini değerlendirir.',
            score: 'Skor',
            benchmark: 'Kıyaslama',
            metrics: 'Metrikler',
            attitudePart: {
              attitudeMetrics: 'Tutum Metrikleri',
              liking: 'Beğeni',
              likingDesc: 'Kitlenin reklama yönelik öznel tutumunu ve genel beğeni düzeyini ölçer.',
              newInformation: 'Yeni Bilgi',
              newInformationDesc: 'Kitlenin reklamdan marka veya ürün hakkında daha önce bilmediği değerli bilgiler edindiğine inanıp inanmadığını ölçer.',
              messageRelevance: 'Mesaj Alakası',
              messageRelevanceDesc: 'Kitlenin reklamda aktarılan bilgileri kendisiyle doğrudan ilişkili algılama düzeyini ölçer.',
              comprehension: 'Anlama',
              comprehensionDesc: 'Reklamın ana mesajının kitle tarafından açık, doğru ve zahmetsiz biçimde anlaşılıp anlaşılmadığını ölçer.',
              credibility: 'Güvenilirlik',
              credibilityDesc: 'Kitlenin aktarılan bilgileri doğru, güvenilir ve inanılır bulma düzeyini ölçer.',
              brandLinkage: 'Marka Bağlantısı',
              brandLinkageDesc: 'Kitlenin reklamı belirli marka ile doğru ve güçlü şekilde ilişkilendirme becerisini ölçer.',
              uniqueness: 'Benzersizlik',
              uniquenessDesc: 'Reklamın markanın rakiplere kıyasla belirgin ve değerli bir benzersizliğe sahip olduğu algısını kurup kurmadığını ölçer.',
              willing: 'Daha Fazla Öğrenme İsteği',
              willingDesc: 'Kitlenin reklamı izledikten sonra marka veya ürün hakkında daha fazla bilgi edinmek için aktif adım atma olasılığını ölçer.',
              purchase: 'Satın Alma Niyeti',
              purchaseDesc: 'Kitlenin gelecekte markanın ürününü seçmeyi veya satın almayı düşünme olasılığını ölçer.',
              share: 'Paylaşılabilirlik',
              shareDesc: 'Kitlenin reklamı veya marka bilgisini başkalarıyla aktif olarak paylaşma olasılığını ölçer.',
              brandLikeLift: 'Marka Beğeni Artışı',
              brandLikeLiftDesc: 'Reklama maruz kalma sonrasında marka veya ürüne yönelik genel beğenideki değişimin yönünü ve derecesini ölçer.',
              purchaseIntentLift: 'Satın Alma Niyeti Artışı',
              purchaseIntentLiftDesc: 'Reklama maruz kalma sonrasında markanın ürününü satın almayı düşünme isteğindeki değişimin yönünü ve derecesini ölçer.',
            },
            dimensionPart: {
              forceDrives: 'Etki Güçleri',
              attension: 'Dikkat',
              emotionalImpact: 'Duygusal Etki',
              messageClarity: 'Mesaj Netliği',
              brandPower: 'Marka Gücü',
              persuasion: 'İkna',
              attentionForce: 'Dikkat Gücü',
              attentionForceDesc: 'Reklamın kitlenin görsel ve işitsel dikkatini yakalama ve sürdürme becerisini ölçer.',
              emotionalForce: 'Duygusal Güç',
              emotionalForceDesc: 'Reklam içeriğinin uyandırdığı anlık, içgüdüsel duygusal rezonans ve dalgalanmanın yoğunluğunu ölçer.',
              messageForce: 'Mesaj Gücü',
              messageForceDesc: 'Reklamın ana mesajının hedef kitle tarafından net biçimde tanınma, doğru anlaşılma ve güçlü hatırlanma etkinliğini ölçer.',
              brandForce: 'Marka Gücü',
              brandForceDesc: 'Reklamın marka kimliğini güçlendirme, marka beğenisini artırma ve güçlü marka bağlantısı kurma etkisini ölçer.',
              persuasiveForce: 'İkna Gücü',
              persuasiveForceDesc: 'Reklamın algıları değiştirme ve davranış niyetlerini yönlendirme konusundaki nihai gücünü ölçer.',
            },
            result: {
              results: 'Sonuçlar',
              pass: 'Geçti',
              notPass: 'Geçmedi',
              adeffScore: 'AdEff Skoru',
              adeffScoreDesc: 'AdEff skoru, reklamların genel etkililiğini ölçmek için tasarlanmıştır.',
              benchmarkDesc: 'Reklamın bulunduğu ülke veya bölgedeki tüm yüklenmiş reklamların ortalama AdEff skoru, performansı karşılaştırmak için kullanılır.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Bekleniyor...',
            description: 'Test raporunuz oluşturuluyor...',
          },
          generating: 'Oluşturuluyor...',
          freeTrialLockText1: 'Deneme modunda tam rapor önizlenemez veya indirilemez.',
          freeTrialLockText2: 'Kilidi açmak için abone olun.',
        },
      },
    },
  },
  professor: {
    account: 'Hesap',
    password: 'Şifre',
    login: 'Giriş',
    expertReviews: 'Uzman Gözüyle',
    adVideoScore: 'Reklam Etkisi İndeksi',
    subjectiveResponseCurve: 'Öznel Tepki Eğrisi',
    indexAnalysis: 'İndeks Analizi',
    keyResult: 'Ana Sonuç',
    theGolden3Seconds: 'Altın 3 Saniye',
    informationTransmission: 'Bilgi Anı',
    brandRelevance: 'Marka Anı',
    interestStimulation: 'İlgi Anı',
    theEnding3Seconds: 'Son 3 Saniye',
    heatMap: 'Isı Haritası',
    suggestion: 'Öneri',
    suggestion1: 'Öneri',
    submit: 'Gönder',
    next: 'Sonraki',
    summary: 'Özet',
    advantages: 'Avantajlar',
    disadvantages: 'Dezavantajlar',
    option1: 'Beklenen',
    option2: 'Beklenenden Farklı',
    resultJudgment: 'Sonuç Değerlendirmesi',
    placeholder: 'Öneri girin',
    waitRateCount: 'Değerlendirmeye İhtiyacınız Olan Reklam Sayısı',
    unfinishedTitle: 'Uyarı',
    unfinishedRate:
      'Geçerli projede hala değerlendirilmemiş içerikler var, devam etmek istediğinize emin misiniz?',
    unfinishedConfirm: 'Devam Et',
    unfinishedCancel: 'İptal Et',
    message: {
      submitSuccess: 'Değerlendirmeniz için teşekkürler',
      submitSuccess1: 'Bu projenin değerlendirmesini tamamladınız, teşekkürler',
      loginSuccess: 'Giriş başarıyla',
      rateUnfinished:
        'Henüz mevcut içeriği değerlendirmediniz, lütfen doldurduktan sonra bir sonraki soruya geçin',
      rateLocation: 'Değerlendirilmemiş içeriklere otomatik olarak yönlendirildiniz',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Ücretsiz Deneme',
      title1: 'Ücretsiz Deneme',
      trial: 'Deneme',
      hiddenBoxText1: 'Birden fazla avantaj, dezavantaj ve öneri tespit edildi',
      hiddenBoxText2: 'Tam rapor almak için abone olun',
      hiddenBoxBtn: 'Abone Ol',
      applyBox: {
        name: 'Adınız',
        tel: 'Telefon Numaranız',
        department: 'Departman',
        role: 'Rol',
        country: 'Ülke',
        city: 'Şehir',
        pleaseEnter: 'Lütfen girin',
        pleaseSelect: 'Lütfen seçin',
        pleaseEnterTheName: 'Lütfen adınızı girin',
        pleaseEnterTheTel: 'Lütfen telefon numaranızı girin',
        pleaseEnterValidTel: 'Lütfen geçerli bir telefon numarası girin',
        pleaseEnterValidEmail: 'Lütfen geçerli bir email girin',
        pleaseSelectTheDepartment: 'Lütfen departmanınızı seçin',
        pleaseSelectTheRole: 'Lütfen rolünüzü seçin',
        pleaseSelectTheCountry: 'Lütfen ülkenizi seçin',
        pleaseEnterTheCity: 'Lütfen şehirinizi girin',
        textIsRequired: 'Bu alan zorunludur',
        submit: 'Gönder',
        tip: 'Her şirkete yalnızca bir kez ücretsiz deneme fırsatı vardır',
      },
      gotTrial: 'Ücretsiz deneme aldınız!',
      goPc: 'Lütfen PC web sürümüne gidin ve projenizi oluşturun.',
      back: 'Geri',
      country: {
        China: 'Çin',
        Japan: 'Japonya',
        Korea: 'Kore',
        Indonesia: 'Endonezya',
        Thailand: 'Tayland',
        Singapore: 'Singapur',
        Malaysia: 'Malezya',
        Vietnam: 'Vietnam',
        Germany: 'Almanya',
        Britain: 'İngiltere',
        France: 'Fransa',
        Italy: 'İtalya',
        Russia: 'Rusya',
        Spain: 'İspanya',
        Turkey: 'Türkiye',
        America: 'Amerika',
        Canada: 'Kanada',
        Brazil: 'Brezilya',
        Other: 'Diğer',
      },
      department: {
        Brand: 'Marka',
        Market: 'Pazar',
        Marketing: 'Pazarlama',
        IT: 'IT',
        Procurement: 'Alım',
        Other: 'Diğer',
      },
      role: {
        President: 'Başkan/Başkan Yardımcısı/Genel Müdür',
        CMO: 'CMO veya diğer C-seviye yöneticiler',
        Director: 'Bölüm Müdürü',
        Manager: 'Bölüm Müdürü',
        Other: 'Diğer',
      },
      message: {
        submitSuccess: 'Değerlendirmeniz için teşekkürler',
        submitFailed: 'Değerlendirmeniz için teşekkürler',
      },
    },
    downloadPptRechargeModal: {
      title: 'Rapor indirilemiyor',
      desc1: 'Deneme sürümünde rapor indirilemez',
      desc2: 'Tam rapor almak için abone olun',
      btn: 'Abone Ol',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Referans Kodu',
      invitationCodeDesc1: 'Referans kodu değiştirilemez, lütfen bizimle iletişime geçin',
      invitationCodeDesc2:
        'Eğer bunu bir acente referansı aracılığıyla kullanıyorsanız, lütfen referans kodunu girin',
      invitationCodePlaceholder: 'Lütfen referans kodunu girin',
      invitationCodeError: 'Geçersiz referans kodu',
      invitationCodeSuccess: 'Referans kodu başarıyla değiştirildi',
      ok: 'Tamam',
      cancel: 'İptal',
    },
    aigcPromotionModal: {
      title: 'AIGC İçerik Üreticisi Avantajları',
      subTitle: 'Hemen kaydolun, <tmp>5</tmp> AI video değerlendirme fırsatı kazanın',
      desc1: 'Kreatiflerinizi değerlendirmek için AdEff AI Creative Testing Etkinliğine katılın.',
      desc2: 'Şimdi kaydolun ve anında 5 ücretsiz test kazanın.',
      registerBtn: 'Test fırsatları için kaydolun',
      tip: 'Yalnızca AIGC içerik üreticisi kampanya girişinden kayıt olan yeni kullanıcılar için geçerlidir',
      floatTitle: 'Ücretsiz test',
    },
  },
}

export default TRANSLATION
